import { Box, Typography } from "@mui/material";
import IosShareIcon from "@mui/icons-material/IosShare";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function MobileInstallPrompt() {
  return (
    <>
      <Typography paragraph>
        {" "}
        Curate is a web app. This means you can install it as an app directly
        from the website. It takes less than 10 seconds...
      </Typography>
      <Box component="ol" sx={{ pl: 3, mt: 1 }}>
        <Typography component="li" gutterBottom>
          On iOS, tap the share icon{" "}
          <IosShareIcon
            fontSize="small"
            sx={{ verticalAlign: "text-bottom" }}
          />{" "}
          from the Safari or Chrome browsers. On Android, tap the menu icon{" "}
          <MoreVertIcon
            fontSize="small"
            sx={{ verticalAlign: "text-bottom" }}
          />{" "}
          from the Chrome browser
        </Typography>
        <Typography component="li" gutterBottom>
          Scroll down and tap "Add to Home Screen" from the available options
          (you may have to tap "Show more")
        </Typography>
        <Typography component="li" gutterBottom>
          On iOS, tap "Add". On Android, tap "Install"
        </Typography>
      </Box>
    </>
  );
}
